export default __webpack_public_path__ + "static/media/no-notification.b623673c.svg";